export default __webpack_public_path__ + "static/media/cannotBePreviewed.cb6b4356.svg";